import { useTranslation } from 'react-i18next';

import { UNKNOWN_VALUE } from '../constants';
import CellText from './CellText';

export interface ExpiresInCellProps {
  /** `ServiceAgreement.requestExpiresIn` from `mapServiceAgreementBody`.
   * Negative means expired. `undefined` renders `'—'` (e.g. a declined row
   * on Requests, PRD 04 "Table": "empty for declined"). */
  requestExpiresIn: number | undefined;
}

/**
 * Expires in cell: "N days" for a live pending/invited row, "Expired by N
 * days" once past `requestExpiresAt` (PRD D3), using the existing
 * `requestExpiredBy` / `days` keys. Shared by Invites (03) and Requests (04).
 */
export default function ExpiresInCell({ requestExpiresIn }: ExpiresInCellProps) {
  const { t } = useTranslation();

  if (requestExpiresIn === undefined) return <CellText text={UNKNOWN_VALUE} />;

  if (requestExpiresIn < 0) {
    return (
      <CellText text={`${t('requestExpiredBy')} ${Math.abs(requestExpiresIn)} ${t('days')}`} />
    );
  }

  return <CellText text={`${requestExpiresIn} ${t('days')}`} />;
}
